import { useTranslation } from 'react-i18next';
import { InformativeBannerWrapper } from '../../../assets/styles/components/informativeBanner.styled';
import { InfoCircle, LinearCross } from '../../icons';
import { IconButton, Paragraph } from '../../Ant';

interface InformativeBannerProps {
  message: string;
  onClose: () => void;
  testId?: string;
}

const InformativeBanner = ({
  message,
  onClose,
  testId = 'informative-banner',
}: InformativeBannerProps) => {
  const { t } = useTranslation();
  return (
    <InformativeBannerWrapper data-testid={testId}>
      <InfoCircle className="icon" />
      <Paragraph $fontsize="13px" $weight={500} $color="title" $lineheight="20px">
        {message}
      </Paragraph>
      <IconButton
        aria-label={t('common:bottomNavigation.close')}
        data-testid={`${testId}-close`}
        className="clear-icon-btn"
        onClick={onClose}
        icon={<LinearCross className="text-clr-title fz-20" />}
      />
    </InformativeBannerWrapper>
  );
};

export default InformativeBanner;
